module.exports = __webpack_public_path__ + "img/三分相.35caba97.svg";